
import {Component, Vue} from 'vue-property-decorator';
import {Decimal} from "decimal.js";
import Template from "@/views/system-management/template/index.vue";
import {customsPackingSet, getCustomsPacking, searchRelatedInventoryPacking} from "@/api/closing-order";
import RelatedInventory from "@/views-oms/closing-position/components/RelatedInventory.vue";

@Component({
  components: {
    RelatedInventory,
    Template}
})
export default class specifyInventory extends Vue {

  private dialogVisible = false;

  private closeDialog() {
    this.modelKeyword = ''
    this.dialogVisible = false;
  }

  private submitSuccess() {
    this.closeDialog();
    this.$emit('success');
    window.location.reload();
  }

  private options = {
    clId: '',
    piInfoId: '',
    supplier: '',
    hqProductName: '',
    maxQty: 0
  }
  public openDialog(clId,row,data:any) {
    this.records = data;
    this.options = {
      clId: clId,
      piInfoId: row.id,
      supplier: row.supplier,
      hqProductName: row.hqProductName,
      maxQty: row.maxSelectedQty
    }
    this.dialogVisible = true;
  }

  private modelKeyword = '';
  private searchLoading = false;
  private async search() {
    this.searchLoading = true;
    try {
     let data:any =  await getCustomsPacking(this.options.clId,{
       model: this.modelKeyword,
       supplierId: this.options.supplier,
       hqProductName: this.options.hqProductName
     });
     this.records = data;
    }catch (e) {
      this.$message.error(e.message);
    }finally {
      this.searchLoading = false;
    }
  }
  private submitInventoryLoading = false;
  private async submitInventory() {
    this.submitInventoryLoading = true;
    this.checkSelectedQty(0);
    let result = this.records
        .flatMap((e) => e.packings)
        .filter(e => e.isSelected)
        .map(e => e.id);
    if (result.length === 0) {
      this.submitInventoryLoading = false;
      return;
    }
    try {
      await customsPackingSet(this.options.clId, {
        piInfoId: this.options.piInfoId,
        maxQty: this.options.maxQty,
        customsPackingIds: result});
      this.submitSuccess();
    }
    catch (e) {
      this.$message.error(e.message);
    }
    finally {
      this.submitInventoryLoading = false;
    }
  }

  private checkSelectedQty(curSelectedQty:number) {
    let selectedQty:number = this.records
        .flatMap((e) => e.packings)
        .filter(e => e.isSelected)
        .map(e => e.totalPcs)
        .reduce((acc, cur) =>  acc + cur,curSelectedQty);
    if (selectedQty > this.options.maxQty) {
      this.$message.error('已选择的产品数量（' + selectedQty + '）不能大于所需库存数量（' + this.options.maxQty + '）');
      return false;
    }
    return true;
  }

  private relatedDialogLoading = false;
  private async openRelatedInventoryRef() {
    this.relatedDialogLoading = true;
    try {
      let data = await searchRelatedInventoryPacking(this.options.clId,{piInfoId: this.options.piInfoId});
      (this.$refs['relatedInventoryRef'] as RelatedInventory).openDialog(this.options.clId,this.options.piInfoId,data);
    }catch ( e) {
      this.$message.error(e.message);
    } finally {
      this.relatedDialogLoading = false;
    }
  }
// table 内容
  private records:InventoryRecord[] =  [];
  private isInnerSelection = false; // 新增标志位,为了防止handleSelectionChange检测到了变化，而做处理。
  /**
   * 内部变化 -> 引起外部变化
   * 内部table 行选中状态更新，同时改变外层table的选中状态
   * @param selection
   * @param row
   * @private
   */
  private handlerInnerTbChange(selection,row:InventoryRecord) {
    // 更新内部table的行选中状态
    row.packings.forEach((packing) => {
      let isSelected = selection.some(i2 => i2.id === packing.id);
      this.$set(packing, 'isSelected', isSelected);
    })
    // 更新外层table的行选中状态
    let outerTbRef: any = this.$refs.outerTbRef;
    this.isInnerSelection = true;
    if (selection.length === 0) {
      outerTbRef.toggleRowSelection(row,false);
    } else {
      outerTbRef.toggleRowSelection(row, true);
    }
    this.isInnerSelection = false;
  }

  /**
   * 外部变化 -> 引起内部变化（updateInnerTbByOuterTb）
   * 外部table的勾选行变化，同时更新内部table的行的选中状态。
   * 如果是内部table更新外部table行选中状态，则不进行同步更新内部table行选中状态。
   * @param selection 选中行
   * @private
   */
  private handleSelectionChange(selection) {
    if (this.isInnerSelection) {
      return;
    }
    let outerTbRef: any = this.$refs.outerTbRef;
    this.records.forEach((row) => {
      const isSelected = selection.some(selectedRow => selectedRow.groupKey === row.groupKey);
      outerTbRef.toggleRowSelection(row, isSelected); // 更新外层表格
      // 更新内部表格的选中状态
      row.packings.forEach((value) => {
        if (!value.canSelected){
          return;
        }
        this.$set(value, 'isSelected', isSelected);
        this.updateInnerTbByOuterTb(value, isSelected, 'innerTbRef_' + row.groupKey);
      });
    });
  }

  /**
   * 内部变化
   * 根据外层table勾选情况，更新内部table的选中状态
   * @param row 外层table当前行数据
   * @param selected 外层table当前行是否被选中
   * @param refName 内部table的ref名称
   * @private
   */
  private updateInnerTbByOuterTb(row, selected,refName) {
    let tbRef: any = this.$refs[refName];
    if (tbRef){
      tbRef.toggleRowSelection(row, selected);
    }
  }
 private getImageExplanation(type) {
    if (type === 'MIX') {
      return '混装';
    }
    if (type === 'DIFFERENCE'){
      return '尾差';
    }
    return '';
 }

  private checkSelectAllForOuterTb(selection) {
    let packings = selection.flatMap(item => item.packings);
    const [firstPacking, ...otherPackings] = packings;
    let hasNotMatched = otherPackings.some(item => !this.checkModel([item], firstPacking));
    let outerTbRef: any = this.$refs.outerTbRef;
    // 校验是否存在不一样型号的产品
    if (hasNotMatched) {
      this.$message.error('存在不一样的产品，请在每一个库存中单独选择主包装。');
      outerTbRef.clearSelection();
      return;
    }
    if (!this.checkSelectedQty(packings.map(item => item.totalPcs).reduce((acc, cur) => acc + cur,0))) {
      outerTbRef.clearSelection();
    }
  }

  /**
   * 校验外层单行全选
   * @param selection
   * @param row
   * @private
   */
 private checkSelect(selection, row) {
    let otherSelections = selection.filter(item => item.groupKey !== row.groupKey);
    let otherSelectedPackings = otherSelections.flatMap((item => item.packings))
        .filter(item => item.isSelected);
    let hasNotMatched = row.packings.some(item => !this.checkModel(otherSelectedPackings, item));
    let outerTbRef: any = this.$refs.outerTbRef;
    if (hasNotMatched || !this.checkSelectedQty(row.packings.map(item => item.totalPcs).reduce((acc, cur) => acc + cur,0))) {
      if (hasNotMatched) {
        this.$message.error('该库存下的主包装内存在不符合其他选中包装的产品，请进入该库存中选择主包装。');
      }
      this.$nextTick(() => {
         outerTbRef.toggleRowSelection(row, false); // 移除外层该行，handlerSelectionChange方法（监测到变化）进行同步更新内部table行选中状态。
      });
      return false;
    }
 }

  /**
   *  校验选择的行的全部号码，是否均不在已选中的行内。
   * @param selection
   * @param packing
   * @private
   */
 private checkSelectByModel(selection, packing, groupKey) {
    let otherSelections = selection.filter(item => item.id !== packing.id);
    const hasMatch = this.checkModel(otherSelections, packing);
    let qtyMoreThan = !this.checkSelectedQty(packing.totalPcs);
    console.log('groupKey', groupKey)
    if (!hasMatch || qtyMoreThan) {
      if (!hasMatch) {
        this.$message.error('该包装内产品和已选中的包装，相同类型的号码，没有一个相同的。请选择其他包装');
      }
      this.$nextTick(() =>
        this.updateInnerTbByOuterTb(packing, false, 'innerTbRef_' + groupKey));
      return false;
    }
 }

  private checkModel(otherSelections, packing) {
   if (otherSelections.length === 0) {
     return true;
   }
    // 定义需要检查的字段列表
    const checkFields = ['guestModel', 'hqOrJrNumber', 'oeNumber', 'refNumber'];
    // 检查是否有任意一个字段匹配
    return otherSelections.some(item =>
        checkFields.some(field =>
            item[field] && packing[field] && item[field] === packing[field]
        )
    );
  }

  private checkSelectAll(selection, groupKey) {
    const [firstSelected, ...otherSelections] = selection;
    // 检查是否存在不匹配的项
    const hasUnmatched = otherSelections.some(
        item => !this.checkModel([item], firstSelected)
    );
    let ref: any = this.$refs['innerTbRef_' + groupKey];
    let qtyMoreThan = !this.checkSelectedQty(0);
    if (hasUnmatched || qtyMoreThan) {
      if (hasUnmatched) {
        this.$message.error('请通过单独勾选处理，因为所有产品中存在号码和其他产品号码不一致的。');
      }
      this.$nextTick(() => ref.clearSelection());
      return false;
    }
 }
}
export class InventoryRecord {
  supplier: string;
  packingList: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  packingCodes: string;
  hqProductName: string;
  declarationDescription: string;
  totalAmount: number;
  totalQty: number;
  packingQty: number;
  purchaseOrderNumber: string;
  purchaseUnitPrice: string;
  createdAt: Date;
  packings: Packing[];
  groupKey: string;
  canSelected:boolean;
  // table中使用的数据
  popoverVisible: boolean;
  constructor() {
    this.supplier = '';
    this.packingList = '';
    this.guestModel = '';
    this.hqOrJrNumber = '';
    this.oeNumber = '';
    this.refNumber = '';
    this.packingCodes = '';
    this.hqProductName = '';
    this.declarationDescription = '';
    this.totalAmount = 0;
    this.totalQty = 0;
    this.packingQty = 0;
    this.purchaseOrderNumber = '';
    this.purchaseUnitPrice = '';
    this.createdAt = null;
    this.packings = [];
    this.popoverVisible = false;
    this.canSelected = false;
    this.groupKey =  '';
  }
}
export class Packing {
  id: string;
  code: string;
  gw: Decimal;
  nw: Decimal;
  volume: Decimal;
  totalPcs: number;
  totalAmount: Decimal;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  canSelected:boolean;
  inventoryType:string;
  // 临时变量，用于提交时确定有哪些数据被选中
  isSelected:boolean;
  constructor() {
    this.id = '';
    this.code = '';
    this.gw = new Decimal(0);
    this.nw = new Decimal(0);
    this.volume = new Decimal(0);
    this.totalPcs = 0;
    this.totalAmount = new Decimal(0);
    this.guestModel = '';
    this.hqOrJrNumber = '';
    this.oeNumber = '';
    this.refNumber = '';
    this.canSelected = false;
    this.inventoryType = '';
    this.isSelected = false;
  }
}
